<template>
  <div>
    <el-row  type="flex" justify="start" class="topLine">
      <el-col :span="3">
        <el-button @click="addCrew" plain type="primary">新增人员</el-button>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="submitAll" :disabled="submitDisabled">全部提交</el-button>
      </el-col>
    </el-row>
    <div class="card" v-for="(item, index) in info" :key="index">
      <el-row>
        <el-col :span="1" style="text-align: right; margin-right: 1rem">
          <span style="color: red">*</span>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请输入姓名" v-model="item.name"></el-input>
        </el-col>
        <el-col :span="3">
          <p v-if="nameValid.indexOf(index) !== -1" style="color: red; line-height: inherit">未输入姓名！</p>
        </el-col>
        <el-col :span="2" style="float: right">
          <el-button type="danger" plain @click="deleteRow(index)">删除本行</el-button>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="8">
          <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :http-request="httpRequestOfSuKangMa"
              :data="{personIndex: index}"
              :on-remove="handleImgRemove"
          >
            <img v-if="item.url.health_code" :src="item.url.health_code" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="tip">苏康码</div>
        </el-col>
        <el-col :span="8">
          <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :http-request="httpRequestOfTripCode"
              :data="{personIndex: index}"
              :on-success="handleAvatarSuccess"
          >
            <img v-if="item.url.trip_code" :src="item.url.trip_code" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="tip">行程码</div>
        </el-col>
        <el-col :span="8">
          <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :http-request="httpRequestOfNucleicIn48h"
              :data="{personIndex: index}"
              :on-success="handleAvatarSuccess"
          >
            <img v-if="item.url.nucleic_acid_report" :src="item.url.nucleic_acid_report" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="tip">48h核酸</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import GLOBAL from "@/utils/global.js";
export default {
  name: "DataAnalysis",
  components: {},
  data() {
    return {
      GLOBAL,
      imageUrl: '',
      info: [
        // {
        //   name: '',
        //   url:{
        //     health_code: '',
        //     trip_code: '',
        //     nucleic_acid_report: '',
        //   },
        // },
      ],
      //姓名判空
      nameValid: [],
    //  提交名单是否为空
      submitDisabled: false,
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    httpRequestOfSuKangMa(param){
      // console.log(param);
      let fileObj = param.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("file", fileObj); // 文件对象
      formData.append('type', '健康码')
      this.$store.dispatch("Health/uploadImg", formData)
          .then((res) => {
            this.info[param.data.personIndex].url.health_code = res.data.data;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    httpRequestOfTripCode(param){
      let fileObj = param.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("file", fileObj); // 文件对象
      formData.append('type', '行程码')
      this.$store.dispatch("Health/uploadImg", formData)
          .then((res) => {
            this.info[param.data.personIndex].url.trip_code = res.data.data;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    httpRequestOfNucleicIn48h(param){
      let fileObj = param.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("file", fileObj); // 文件对象
      formData.append('type', '核酸报告')
      this.$store.dispatch("Health/uploadImg", formData)
          .then((res) => {
            this.info[param.data.personIndex].url.nucleic_acid_report = res.data.data;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    handleImgRemove(){

    },
    addCrew(){
      this.info.push({
        name: '',
        url:{
          health_code: '',
          trip_code: '',
          nucleic_acid_report: '',
        },
      })
    },
    deleteRow(index){
      this.info.splice(index, 1);
    },
    submitAll(){
      //姓名判空
      this.nameValid = [];
      this.info.forEach( (item, index) => {
        if(item.name === ''){
          this.nameValid.push(index);
        }
      })
      if(this.nameValid.length === 0){
        for(let i = 0; i < this.info.length; i ++){
          this.$store.dispatch('Health/submitHealthInfo', this.info[i])
              .then((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
                this.$message({
                  type: 'success',
                  message: res.data.data,
                })
                this.info = [
                  {
                    name: '',
                    url:{
                      health_code: '',
                      trip_code: '',
                      nucleic_acid_report: '',
                    },
                  },
                ];
              })
              .catch((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
              })
        }
      }else{
        this.$message({
          type: 'error',
          message: '填写不完整'
        });
      }
    }
  },
  watch: {
    //空名单的时候不提交
    "info.length"() {
      this.submitDisabled = this.info.length === 0;
    }
  }
};
</script>

<style scoped>
.topLine{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eee;
  margin-bottom: 1rem;
}
.card{
  margin-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}
.avatar-uploader{
  /*border: 1px solid red;*/
  margin-top: 0.5rem;
}
.avatar-uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.tip{
  color: #8c939d;
}
</style>
